/**
 * @generated SignedSource<<d4920bb782a229bd9fbbb3a473eee196>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SearchOptOutEntity = "chat_channel" | "chat_message" | "content_usage" | "feed" | "occurrence" | "post" | "product" | "user" | "%future added value";
export type SearchOptOutRole = "admin" | "member" | "owner" | "%future added value";
export type SearchContextQuery$variables = {
  id: string;
};
export type SearchContextQuery$data = {
  readonly organization: {
    readonly id?: string;
    readonly searchConfig?: string | null;
    readonly viewerMembership?: {
      readonly searchOptOuts: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entity: SearchOptOutEntity;
            readonly id: string;
            readonly role: SearchOptOutRole;
          };
        }>;
      };
    } | null;
  } | null;
};
export type SearchContextQuery = {
  response: SearchContextQuery$data;
  variables: SearchContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchConfig",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "SearchOptOutNodeConnection",
  "kind": "LinkedField",
  "name": "searchOptOuts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchOptOutNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchOptOut",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "role",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entity",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchContextQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationMembership",
                "kind": "LinkedField",
                "name": "viewerMembership",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SearchContextQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationMembership",
                "kind": "LinkedField",
                "name": "viewerMembership",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "52c913f6bcbc3576c2c7f26dbf4d5a22",
    "id": null,
    "metadata": {},
    "name": "SearchContextQuery",
    "operationKind": "query",
    "text": "query SearchContextQuery(\n  $id: ID!\n) {\n  organization: node(id: $id) {\n    __typename\n    ... on Organization {\n      id\n      searchConfig\n      viewerMembership {\n        searchOptOuts {\n          edges {\n            node {\n              id\n              role\n              entity\n            }\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1d4d2bd64aad1885b4b43ba868caeb34";

export default node;
